import axios, { AxiosPromise } from "axios";

import { AuthenticationStore } from "./authenticationStore";
import { authConfig, isIdentityServiceEnabled } from "./oidc-config";

const tokenEndpoint = isIdentityServiceEnabled()
  ? `${authConfig.authority}/oauth2/token`
  : `${authConfig.authority}/oauth/v2/token`;

function getNewAccessToken(refreshToken: string) {
  return axios.post(
    tokenEndpoint,
    {
      grant_type: "refresh_token",
      refresh_token: refreshToken,
      client_id: `${authConfig.client_id}`,
    },
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
}

let refreshPromise: AxiosPromise | undefined;

export const refreshAccessToken = async (): Promise<void> => {
  try {
    const AS = AuthenticationStore();
    const refreshToken = AS.getRefreshToken();

    refreshPromise = refreshPromise || getNewAccessToken(refreshToken);
    const response = await refreshPromise;

    AS.saveAccessToken(response.data);
  } catch {
    // Swallow so the request proceeds with the stale token; the resulting 401
    // clears the session and reloads, which is the recovery path callers rely on.
  } finally {
    // Clear so the next refresh mints a fresh token instead of replaying this one.
    refreshPromise = undefined;
  }
};
